module.exports = __webpack_public_path__ + "static/media/files.e856d15c.svg";